<template>

        <div class="col-span-2 row-span-2 vld-parent">

            <!-- BEGIN HOVER PREVIEW TRIGGER -->
            <div class="absolute w-full cursor-pointer" style="height: 275px; z-index: 99;" @mouseenter="startVideoPreview" @mouseleave="endVideoPreview" @click="openPlayer"></div>
            <!-- END HOVER PREVIEW TRIGGER -->

            <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

            <div v-if="visibleOnHover" class="absolute z-10 w-full rounded-t-lg cursor-pointer overflow-hidden">

                <preview-video-player :videoSource="videoSource" :is_legacy="content.legacy"></preview-video-player>

            </div>

            <div class="relative desktop-large-item shadow flex flex-col h-full cursor-pointer" @click="openPlayer">

                <img :src="image" alt="" @load="loadingFinished" @error="setDefaultThumb" ref="thumbnailImage" />

                <div v-if="triggeringPreview" class="absolute w-full">
                    <progress-bar size="small"
                                  :val="hoverProgress"
                    ></progress-bar>
                </div>

                <p class="text-theme-main hover:text-theme-title px-6 pt-6 pb-4 text-xl leading-tight font-bold bg-theme-level4" v-text="title"></p>
                <div id="abstract-text" class="w-full px-6 pt-1 pb-4 bg-theme-level4 leading-normal text-theme-discrete text-sm self-start" v-text="abstract">
                </div>

                <div id="flex-spacer" class="flex-1 bg-theme-level4 h-full"></div>

                <span class="flex-1 px-6 pb-4 pt-4 text-base text-theme-discrete flex flex-row items-center bg-theme-level4">
                    <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                    <span class="flex-1">{{ translate('published-on') }} <span v-text="date"></span>, {{ translate('at') }} <span v-text="time"></span></span>
                    <!--<i id="module-options-button"
                       class="relative material-icons text-theme-muted hover:text-theme-discrete local-hover-target"
                       style="font-size: 26px;right: -10px;"
                       @click.stop="showContextMenu"
                       @mouseleave="hideContextMenu"
                    >more_vert</i>-->
                    <i id="module-options-button"
                       class="relative material-icons text-theme-muted hover:text-theme-discrete"
                       style="font-size: 26px;right: -10px;"
                       @click.stop="showContextMenu"
                       @mouseleave="hideContextMenu"
                    >more_vert</i>
                </span>

                <!-- BEGIN Module Controls -->
                <!--<div class="local-hover-target-secondary transform transition-all duration-200">-->
                <div class="transform transition-all duration-200">
                    <div class="px-4 text-base text-theme-discrete flex flex-row
                                items-center justify-between bg-theme-level4">
                        <div class="pb-4 ml-2">

                            <i v-if="userAuthenticated" class="material-icons pl-2 pt-2 w-10 h-10 icon-circled text-theme-discrete hover:text-theme-main" :title="translate('playlist-add')" @click.stop="addToPlaylist">playlist_add</i>
                            <i v-else class="material-icons mr-2 pl-2 pt-2 w-10 h-10 text-theme-discrete opacity-25 cursor-default">playlist_add</i>

                            <i v-if="userAuthenticated" class="material-icons pl-2 pt-2 w-10 h-10 icon-circled text-theme-discrete hover:text-theme-main" :title="translate('playlist-watch-later')" @click.stop="addToWatchLater">av_timer</i>
                            <i v-else class="material-icons mr-2 pl-2 pt-2 w-10 h-10 text-theme-discrete opacity-25 cursor-default">av_timer</i>

                            <!--<i class="material-icons mr-2 pl-2 pt-2 w-10 h-10 text-theme-discrete opacity-25 cursor-default" @click.stop="">av_timer</i>-->
                        </div>
                        <div class="pb-4 flex flex-row">
                            <div class="mr-1">

                                <!-- FACEBOOK -->
                                <span @click.stop="">
                                    <ShareNetwork
                                        network="facebook"
                                        :url="shareableLinkCode"
                                        :title="title"
                                        :description="abstract"
                                    >
                                        <i class="material-icons mr-1 pl-2 pt-2 w-10 h-10 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                                                <path d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                                <!-- TWITTER -->
                                <span @click.stop="">
                                    <ShareNetwork
                                        network="twitter"
                                        :url="shareableLinkCode"
                                        :title="title"
                                        hashtags="telesurtv"
                                        twitter-user="telesurtv"
                                    >
                                        <i class="material-icons mr-1 pl-2 pt-2 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main" style="height: 40px; width: 40px;">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                                                <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                                <!-- WHATSAPP -->
                                <span @click.stop="">
                                    <ShareNetwork
                                        network="whatsapp"
                                        :url="shareableLinkCode"
                                        :title="title"
                                        :description="abstract"
                                    >
                                        <i class="material-icons mr-1 pl-2 pt-2 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main" style="height: 40px; width: 40px;">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                                                <path d="M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                                <!-- YOUTUBE -->
                                <span @click.stop="">
                                        <!--<i class="material-icons mr-1 pl-2 pt-2 icon-circled text-theme-discrete hover:text-theme-main" style="height: 40px; width: 40px;">-->
                                        <i class="material-icons mr-1 pl-2 pt-2 text-theme-discrete opacity-25 cursor-default" style="height: 40px; width: 40px;" @click.stop="">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                                                <path d="M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"/>
                                            </svg>
                                        </i>
                                </span>

                                <!-- SHAREABLE LINK -->
                                <span @click.stop="getShareableLink">
                                    <i class="material-icons mr-1 pl-2 pt-2 icon-circled text-theme-discrete hover:text-theme-main" style="height: 40px; width: 40px;">
                                        <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                                            <path d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                                        </svg>
                                    </i>
                                </span>

                            </div>

                            <i v-if="downloadable" class="material-icons mt-0 mr-2 pl-2 pt-2 icon-circled text-theme-discrete hover:text-theme-main" style="width: 40px; height: 40px;" @click.stop="downloadContent">get_app</i>
                            <i v-else class="material-icons mt-0 mr-2 pl-2 pt-2 icon-circled text-theme-discrete opacity-25 cursor-default" style="width: 40px; height: 40px;" @click.stop="">get_app</i>
                        </div>
                    </div>
                </div>
                <!-- END Module Controls -->
                <div id="media-duration"
                     class="absolute bg-theme-dropdowndismissal w-32 h-8
                                        text-theme-control-label text-center pt-2 opacity-75
                                        border border-theme-control-label rounded-md"
                     style="top: 38%; right: 12px;  z-index: 10;" v-text="duration"></div>

                <div v-if="contextMenuVisible" id="context-menu"
                     class="absolute p-4 w-48 bg-theme-level4 text-sm rounded-lg border border-theme-level1 shadow-xl"
                     style="bottom: 70px; right: 36px;"
                     @mouseenter="showContextMenu"
                     @mouseleave="hideContextMenu"
                >
                    <ul>
                        <li @click.stop="getEmbedCode" class="text-theme-discrete hover:text-theme-main">{{ translate('embed-code')}}</li>
                        <li v-if="userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                            @click.stop="editContent" class="text-red-300 hover:text-red-500 cursor-pointer" style="margin-top: 0.75rem;">
                            <span>{{ translate('content-edit-in-module') }}</span>
                        </li>
                    </ul>
                </div>

            </div>

            <div v-if="embedCodePanelVisible" class="fixed w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
                <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 22rem;">
                    <span class="text-base text-theme-main font-bold mb-4">{{ translate('embed-code-title') }}</span>
                    <span class="text-sm text-theme-discrete font-bold mb-6">{{ translate('embed-code-description') }}</span>
                    <div class="text-sm text-theme-discrete mb-6">
                        <pre style="white-space: pre-wrap;"><code>{{ embedCode }}</code></pre>
                    </div>
                    <div class="flex flex-row items-center justify-center">
                        <button class="flex flex-row items-center justify-center text-base hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                                :class="{'bg-theme-controls3': !embedCodeWasCopied && !embedCodeHadError, 'bg-green-500 hover:bg-green-500': embedCodeWasCopied, 'bg-red-500 hover:bg-red-500': embedCodeHadError}"
                                @click.stop="copyEmbedCodeToClipboard">
                            {{ copy_label }}
                        </button>
                        <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                                @click="embedCodePanelVisible=false">
                            {{ translate('close') }}
                        </button>
                    </div>
                </div>
            </div>
            <!--<div v-if="embedCodePanelVisible" class="fixed w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
                <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 22rem;">
                    <span class="text-base text-theme-main font-bold mb-4">{{  translate('embed-code-title') }}</span>
                    <span class="text-sm text-theme-discrete font-bold mb-6">{{ translate('embed-code-description') }}</span>
                    <div class="text-sm text-theme-discrete mb-6">
                        <pre style="white-space: pre-wrap;"><code>{{ embedCode }}</code></pre>
                    </div>
                    <div class="flex flex-row items-center justify-center">
                        <button class="flex flex-row items-center justify-center text-base hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                                :class="{'bg-theme-controls3': !embedCodeWasCopied && !embedCodeHadError, 'bg-green-500 hover:bg-green-500': embedCodeWasCopied, 'bg-red-500 hover:bg-red-500': embedCodeHadError}"
                                @click.stop="copyEmbedCodeToClipboard">
                            {{ copy_label }}
                        </button>
                        <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                                @click="embedCodePanelVisible=false">
                            {{ translate('close') }}
                        </button>
                    </div>
                </div>
            </div>-->

            <div v-if="shareableLinkPanelVisible" class="fixed w-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999; height: 100vh;">
                <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 16rem;">
                    <span class="text-base text-theme-main font-bold mb-4">{{  translate('share-link-title') }}</span>
                    <span class="text-sm text-theme-discrete font-bold mb-10">{{ translate('share-link-description') }}</span>
                    <div class="text-sm text-theme-discrete mb-12">
                        <code>{{ shareableLinkCode }}</code>
                    </div>
                    <div class="flex flex-row items-center justify-center">
                        <button class="flex flex-row items-center justify-center text-base text-theme-control-label rounded-lg px-4 w-32 h-10"
                                :class="{'bg-theme-controls2 hover:bg-theme-controls1': !shareableLinkWasCopied && !shareableLinkHadError, 'bg-green-500 hover:bg-green-500': shareableLinkWasCopied, 'bg-red-500 hover:bg-red-500': shareableLinkHadError}"
                                @click.stop="copyLinkToClipboard">
                            {{ copy_label }}
                        </button>
                        <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                                @click.stop="shareableLinkPanelVisible=false">
                            {{ translate('close') }}
                        </button>
                    </div>
                </div>
            </div>

        </div>

</template>

<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import ProgressBar from 'vue-simple-progress';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            Loading,
            ProgressBar
        },

        data() {
            return {
                contentId: this.content.id,
                /*image: process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url,*/
                download_url: this.content.filename,
                title: this.content.title,
                abstract: this.content.abstract.substring(0, 120) + '...',
                date: (this.content.publish_date).split(' ')[0],
                time: (this.content.publish_date).split(' ')[1],
                duration: this.content.media_duration,

                contextMenuVisible: false,
                embedCodePanelVisible: false,
                shareableLinkPanelVisible: false,

                copy_label: this.translate('copy'),
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,

                embedCodeWasCopied: false,
                embedCodeHadError: false,

                componentLoading: true,

                visibleOnHover: false,
                timer: '',
                triggeringPreview: false,
                hoverProgress: 0,

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
            }
        },

        props: [
            'content',
            'currentlocale',
            'legacy',
            'default_thumbnail'
        ],

        computed: {

            userAuthenticated() {
                return window.Laravel.user
            },

            userRole() {

                return window.Laravel.userRole

            },

            embedCode() {

                let tmp = '<div>\n' +
                    '  <div style="position:relative;overflow:hidden; padding-bottom:58%;height:100%;">\n' +
                    '    <iframe src="https://' +
                    window.location.hostname + '/embed/' + this.legacy + '/' + this.contentId +
                    '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen style="position:absolute;width:100%;height:100%;top:0;left:0;">\n' +
                    '    </iframe>\n' +
                    '  </div>\n' +
                    '</div>'

                return tmp;
            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.contentId;

            },

            downloadable() {

                return this.content.restrictions === 'Abierto' || this.content.restrictions === 'Open';

            },

            image() {
                if(this.legacy) {
                    if(this.content.thumbnail_url !== '') {
                        return process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                    } else {
                        return this.default_thumbnail
                    }
                } else {
                    return process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                }
            },

            videoSource() {

                if(this.legacy) {
                    return this.ENV_CloudFront_Legacy_DNS_Name + this.content.storage_url;
                } else {
                    return this.ENV_CloudFront_DNS_Name + this.content.storage_url;
                }

            }

        },

        methods: {

            editContent() {
                window.location='/' + this.currentlocale + '/admin/content/edit/' + this.contentId;
            },

            setDefaultThumb() {

                this.$refs.thumbnailImage.src = this.default_thumbnail

            },

            addToPlaylist() {

                this.$root.shared.contentIdToAddToPlaylist = this.contentId
                this.$root.shared.playlistChooserVisible = true

            },

            addToWatchLater() {

                axios.get('/' + this.currentlocale + '/watchlater/add/' + this.contentId)
                    .then((response) => {
                        if(response.data === 'added') {
                            this.flashMessage.success({
                                title: '',
                                message: this.translate('playlist-added') + ' ' + this.translate('playlist-watch-later'),
                                blockClass: 'p-6',
                                x: 25,
                                y: 150,
                                time: 3000
                            });
                        }
                        if(response.data === 'exists') {
                            this.flashMessage.warning({
                                title: '',
                                message: this.translate('playlist-already-added'),
                                blockClass: 'p-6',
                                x: 25,
                                y: 150,
                                time: 3000
                            });
                        }
                    })
                    .catch((error) => {
                        console.log('ERROR trying to add item to Watch Later List: ' + error)
                    })

            },

            startVideoPreview() {

                this.triggeringPreview = true

                this.timer = setInterval(
                    () => {
                        this.hoverProgress += 10
                        if(this.hoverProgress >= 130) {
                            clearInterval(this.timer)
                            this.triggeringPreview = false
                            this.hoverProgress = 0
                            this.visibleOnHover = true
                        }
                    }, 100);

            },

            endVideoPreview() {

                this.triggeringPreview = false
                this.visibleOnHover = false
                this.hoverProgress = 0
                clearInterval(this.timer)

            },

            loadingFinished() {
                this.componentLoading=false
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            openPlayer() {

                // Before opening the player, and for several reasons, we will update the browser's
                // address bar with the content URL; before that, we will store the previous URL in order
                // to be able to restore it once the player view is closed
                this.$root.shared.previousPageURL = window.location.href
                document.title = this.content.title
                window.history.pushState({ "pageTitle":this.content.title }, this.content.title, '/' + this.currentlocale + '/content/' + this.content.id)

                // Now, we can move on:
                this.endVideoPreview()
                /*console.log('Firing up the player...');*/
                Event.fire('showPlayer', { language: this.currentlocale , data: this.content });
            },

            showContextMenu() {
                this.contextMenuVisible = true;
            },

            hideContextMenu() {
                this.contextMenuVisible = false;
            },

            getEmbedCode() {
                this.contextMenuVisible = false;
                this.embedCodePanelVisible = true;
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            downloadContent() {

                if(this.legacy) {
                    window.location=process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME + this.content.filename;
                } else {
                    window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.content.filename + '/' + this.content.filename + '.mp4';
                }
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    console.log(e)
                })
            },

            copyEmbedCodeToClipboard() {
                this.$copyText(this.embedCode).then((e) => {
                    this.setCopyLabelOk();
                    this.embedCodeWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.embedCodeHadError=true;
                    console.log(e)
                })
            }
        },

        created() {
            Event.fire('increaseLargeCounter');
        }

    }
</script>

<style scoped>

    .desktop-hs > li,
    .desktop-large-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        /*max-height: 580px;*/
    }

    .icon-circled {
        background-color: var(--txt-copy-5);
    }

    .icon-circled:hover {
        background-color: var(--txt-copy-6);
        fill: var(--txt-main);
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    .local-hover-trigger .local-hover-target-secondary {
        visibility: hidden;
        opacity: 0;
        height: 0;
    }

    .local-hover-trigger:hover .local-hover-target-secondary {
        visibility: visible;
        opacity: 1;
        height: 4rem;
    }

    .local-hover-trigger .local-hover-target {
        visibility: hidden;
        opacity: 0;
    }

    .local-hover-trigger:hover .local-hover-target {
        visibility: visible;
        opacity: 1;
    }

</style>
